export const SET_INVOICE_FILTER_VALUE = 'SET_INVOICE_FILTER_VALUE';
export const EXPAND_INVOICE_FILTER = 'EXPAND_INVOICE_FILTER';
export const APPLY_INVOICE_FILTERS_SUCCESS = 'APPLY_INVOICE_FILTERS_SUCCESS';
export const RESTORE_INVOICE_FILTERS = 'RESTORE_INVOICE_FILTERS';
export const CLEAR_ALL_INVOICE_FILTERS = 'CLEAR_ALL_INVOICE_FILTERS';
export const CLEAR_INVOICE_FILTER = 'CLEAR_INVOICE_FILTER';
export const SET_INVOICE_FITLER_VALIDATION_ERROR = 'SET_INVOICE_FITLER_VALIDATION_ERROR';
export const ENABLE_INVOICE_FILTER = 'ENABLE_INVOICE_FILTER';
export const DISABLE_INVOICE_FILTER = 'DISABLE_INVOICE_FILTER';
export const RESET_INVOICE_FILTERS = 'RESET_INVOICE_FILTERS';



// WEBPACK FOOTER //
// ./src/redux/invoiceFilters/InvoiceFiltersConstants.js